import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { GamesPointsListLayer } from '../components/GamesPoints/GamesPointsListLayer'

export const GamesPointsListPage = () => {
  return (
    <MasterLayout>
        <GamesPointsListLayer   />
    </MasterLayout>
  )
}
